import { tuple } from './type';

export var PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/_util/colors.js
// module id = 641
// module chunks = 0